import { TestProgress } from '../types/tests';

const STORAGE_PREFIX = 'psycho_test_';

export const saveTestProgress = (progress: TestProgress): void => {
    try {
        const key = `${STORAGE_PREFIX}${progress.testId}`;
        localStorage.setItem(key, JSON.stringify(progress));
    } catch (error) {
        console.error('Failed to save test progress:', error);
    }
};

export const loadTestProgress = (testId: string): TestProgress | null => {
    try {
        const key = `${STORAGE_PREFIX}${testId}`;
        const data = localStorage.getItem(key);
        if (!data) return null;
        return JSON.parse(data) as TestProgress;
    } catch (error) {
        console.error('Failed to load test progress:', error);
        return null;
    }
};

export const clearTestProgress = (testId: string): void => {
    try {
        const key = `${STORAGE_PREFIX}${testId}`;
        localStorage.removeItem(key);
    } catch (error) {
        console.error('Failed to clear test progress:', error);
    }
};
